"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var BasciInfoModule = /** @class */ (function (_super) {
    __extends(BasciInfoModule, _super);
    function BasciInfoModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询房间信息
     * @param roomId 房间Id
     */
    BasciInfoModule.prototype.queryRoomBasicInfo = function (roomId, token) {
        return this.gatewayClient.queryRoomBasicInfo(roomId, token);
    };
    /**
     * 更改房间销售状态
     * @param flag 销售状态（1销售中 2删除 3下架 4筹建中 5售前展示）
     * @param roomId 房间id
     * @param user 操作人
     */
    BasciInfoModule.prototype.updataRoomFlag = function (flag, roomId, user, token) {
        return this.gatewayClient.updataRoomFlag(flag, roomId, user, token);
    };
    /**
     * 获取房间二维码
     * @param roomId 房间Id
     */
    BasciInfoModule.prototype.createQrCode = function (roomId, token) {
        return this.gatewayClient.createQrCode(roomId, token);
    };
    /**
     * 楼宇批量解绑房间
     * @param ids
     */
    BasciInfoModule.prototype.unbindRelationRoomByIds = function (ids, token) {
        return this.gatewayClient.unbindRelationRoomByIds(ids, token);
    };
    return BasciInfoModule;
}(gateway_module_1.GatewayModule));
exports.BasciInfoModule = BasciInfoModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9iYXNpY0luZm8vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsb0RBQWtEO0FBRWxEO0lBQXFDLG1DQUFhO0lBQWxEOztJQXVDQSxDQUFDO0lBdENDOzs7T0FHRztJQUNJLDRDQUFrQixHQUF6QixVQUEwQixNQUFjLEVBQUUsS0FBYTtRQUNyRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxrQkFBa0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDOUQsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksd0NBQWMsR0FBckIsVUFDRSxJQUFZLEVBQ1osTUFBYyxFQUNkLElBQVksRUFDWixLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3RFLENBQUM7SUFFRDs7O09BR0c7SUFDSSxzQ0FBWSxHQUFuQixVQUFvQixNQUFjLEVBQUUsS0FBYTtRQUMvQyxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3hELENBQUM7SUFFRDs7O09BR0c7SUFDSSxpREFBdUIsR0FBOUIsVUFBK0IsR0FBVyxFQUFFLEtBQWE7UUFDdkQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsdUJBQXVCLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFDSCxzQkFBQztBQUFELENBQUMsQUF2Q0QsQ0FBcUMsOEJBQWEsR0F1Q2pEO0FBdkNZLDBDQUFlIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/basicInfo/index.js
// module id = 217
// module chunks = 44